import React from 'react'

interface IProps {
    className?: string
    src: string
    alt?: string
    onClick?: (e?: any) => void
    containerClassName?: string
    isResizeFit?: boolean
}

const WizImage: React.FC<IProps> = ({className, src, alt = '', onClick, containerClassName, isResizeFit}) => {
    return (
        <div onClick={onClick && onClick} className={`flex-none ${containerClassName}`}>
            <img className={`${className}`} src={isResizeFit ? src + '?action=fit' : src} alt={alt} />
        </div>
    )
}

export default WizImage
